// extracted by mini-css-extract-plugin
module.exports = {"root":"root-PEDUZ","price__icon":"price__icon-2oZFR","price__iconWrapper":"price__iconWrapper-20G7a"};